/* eslint-disable max-len */

export default {
  lang: "Spanish",
  homeScreen: {
    title: "Capital Mundial de los Parques Temáticos",
    stayConnected: "¡Sigue conectado!",
    comingSoon: "Próximamente",
    messages: "Mensajes",
  },
  notification: {
    newAndNow: "¡Novedades!",
    alert: "Alerta",
    message: "Mensaje",
    contest: "Concurso",
    badge: "Nueva Insignia",
    "content-update": "Actualización de Contenido",
    events: "Eventos",
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.",
      homeTitleSub:
        "Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci",
      noAccount:
        "No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.",
      continueButton: "Continuar",
      success:
        "Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.",
      successNewAccount:
        "Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.",
      loginButton: "Inicio de sesión",
      matchFound:
        "Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.",
      magicLink:
        "Inicie sesión a través de un enlace en su correo electrónico:",
      magicLinkButton: "Solicitar Magic Link",
      magicLinkTitle:
        "Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.",
      otherEmailButton: "Enviar",
      title:
        "Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.",
      titleIndustry:
        "Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.",
      register: "Crear una cuenta",
      agent: "Asesor de viajes",
      visitor: "Visitante del sector",
      step1: "Paso 1: Tipo de usuario",
      step2: "Paso 2: Crear una cuenta",
      step3: "Paso 3: Cree su perfil",
      marketingOptIn:
        "¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?",
      optIn: "Sí, me interesa",
      optOut: "No me interesa",
      step2Sub1: "Háblenos de usted",
      step2Sub2: "Háblenos de su empresa",
      privacyHead: "PREFERENCIAS DE COMUNICACIÓN",
      privacySub:
        "Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.",
      privacy:
        "Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.",
      store: "Descarga fácilmente este programa en tu tienda de aplicaciones:",
      powered: "PODER DE",
      toastMessage: {
        forgotSuccess:
          "Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.",
        emailNotExisting:
          "La dirección de correo electrónico que has introducido no existe.",
        magicLinkMessage:
          "Por favor, espera, te estamos registrando ahora mismo.",
        magicLinkError:
          "No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.",
        magicLinkError1:
          "No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.",
        magicLinkError2:
          "No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.",
        magicLinkSuccess:
          "Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.",
        magicLinkErrorWait:
          "Por favor, espera 5 minutos entre peticiones de enlace mágico.",
        emailNotFoundError:
          "La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta.",
      },
      errors: {
        zipCodeNotFound: "Código postal no encontrado, inténtelo de nuevo",
        zipCodeOnlyNumbers: "El código postal sólo puede contener números",
        password: "Introduzca una contraseña",
        passwordNotMatching: "Las contraseñas introducidas no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
        emailExists:
          "Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.",
        fillInAllFields: "Rellene todos los campos obligatorios",
        fillInEmail:
          "Por favor, introduzca su dirección de correo electrónico.",
        emailNotExisting:
          "La dirección de correo electrónico que ha introducido no existe.",
      },
      fields: {
        forgotSubCopy: "¿Has olvidado tu contraseña y quieres cambiarla? ",
        forgotSubCopy2:
          "¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ",
        city: "Ciudad",
        companyName: "Nombre de la empresa",
        role: "Su función",
        description: "¿Cuál describe mejor la actividad de su empresa?",
        country: "País",
        password: "Contraseña",
        passwordRegister: "Elija una contraseña (mínimo 8 caracteres)",
        passwordConfirm: "Confirmar contraseña",
        firstName: "Nombre",
        lastName: "Apellido (Familia)",
        agency: "Nombre de su agencia",
        title: "Su función (seleccione una)",
        company: "Nombre de la empresa",
        select: "Seleccione una opción",
        state: "Estado",
        province: "Provincia/Región/Estado",
        zipCode: "Código postal",
        postalCode: "Código postal",
        affiliate: "¿A qué grupo está afiliada su agencia PRINCIPAL?",
        hostAgency: "¿Su agencia de acogida?",
        executive: "Ejecutivo",
        management: "Gestión",
        marketing: "Marketing",
        sales: "Ventas",
        coordinator: "Coordinador",
        opt: "Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.",
        optMarketing:
          "Manténgase en contacto con TravPRO en relación con programas y eventos similares.",
        retail: "Fachada de tienda",
        home: "Agente a domicilio",
        independent: "Contratista independiente",
        host: "Organismo anfitrión",
        call: "Centro de llamadas o agencia web",
        other: "Otros",
        describes:
          "¿Qué es lo que mejor describe su actividad y la de su agencia?",
      },
    },
    title:
      "Programa de capacitación de asesores profesionales de turismo y ventas",
    welcome: {
      headerTop: "Bienvenida a",
      headerBottom: "Orlando Travel Academy",
    },
    sellingPoints: {
      0: "Obtenga 2 créditos CEU de Travel Institute",
      1: "Cinco (5) Capítulos de la Fundación para obtener el Diploma",
      2: "Directorio de socios y exhibiciones de consumidores",
      3: "Colateral de marketing listo para usar",
      4: "Recursos Integrados de Ventas de Alto Impacto",
      5: "Consejos y promociones de expertos",
      6: "Noticias y actualizaciones oportunas",
    },
    emailPrompt:
      "Ingresa tu dirección de correo electrónico y tu contraseña para confirmar que eres un asesor profesional de turismo.",
    tAndC: {
      agree: "Al continuar, aceptas nuestra ",
      privacyPolicy: "política de privacidad",
      and: " y ",
      termsConditions: "términos y condiciones",
    },
    fields: {
      agency: "Agencia",
      email: "Correo electrónico",
      password: "Contraseña",
      passwordConfirm: "Confirma tu contraseña *",
      firstName: "Nombre *",
      lastName: "Apellido *",
      city: "Ciudad *",
      agencyName: "Nombre de la agencia *",
      stateProvince: "Estado/provincia *",
      required: "Requerido",
      invalidEmail: "Dirección de correo electrónico no válida",
      opt: "¡Mantente en contacto! ¡Sí, me gustaría optar por recibir comunicaciones de Orlando Travel Academy que me mantengan informado sobre noticias, eventos, incentivos, de FAM y más!",
      complete: "Paso 2: Complete su perfil",
      tell: "Cuéntanos sobre ti",
      title: "Título comercial *",
      host: "Nombre de la agencia anfitriona",
      country: "País/Región",
      select: "Seleccione una opción a continuación",
      header2: "¿Qué segmento(s) vende principalmente?",
      step2: "Describe tu negocio",
      leisure: "Ocio",
      corporate: "Corporativo",
      group: "Grupo",
      affiliate: "¿Cuál es su afiliación principal?",
      forgot:
        "¿Ha olvidado su contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.",
    },
    forgot: "Restablecer contraseña",
    noAgent: {
      noAgentButton: "No soy asesor",
      title: "Agradecemos tu interés en Orlando Travel Academy",
      messageWeb:
        "El contenido de este sitio es exclusivo para asesores profesionales de turismo. Para obtener más información sobre Orlando, visita:",
      messageMobile:
        'Algunos contenidos en esta aplicación son exclusivos para asesores profesionales de turismo, pero puedes echar un vistazo a lo que ofrece esta aplicación haciendo clic en "Continuar".',
      continue: "Continuar",
      visitWebsite: "Visita el sitio web",
    },
    newUser: "Nuevo usuario",
    register: "Regístrate",
    registered: "Este correo electrónico ya se encuentra registrado",
    forgot: "Olvidé mi contraseña",
    header:
      "Tómese un momento para completar toda la información a continuación, ya que esto es lo que llenará su perfil e información de contacto.",
    step1:
      "Paso 1: Complete su dirección de correo electrónico y elija una contraseña.",
  },
  welcomeScreen: {
    title: "Te damos la bienvenida a Orlando Travel Academy",
    helloUser: "Hola, {{name}}",
    hello: "Hola:",
    fromAgency: "de {{agency}}",
    notUser: "¿No eres {{name}}?",
    introOnline:
      "¡Capacítate de manera inmediata en línea o precarga el contenido para que esté siempre disponible y puedas usarlo sin conexión!",
    introOffline:
      "Ya tienes la última versión precargada. ¡Comienza la capacitación o la venta en cualquier momento y lugar!",
    startTraining: "Comienza el aprendizaje",
    continueTraining: "Continúa con el aprendizaje",
    graduated: "¡Felicitaciones!",
    downloader: {
      preload: "Precargar",
      stop: "Detener",
      init: "Iniciando...",
      lastUpdate: "Última actualización:",
    },
  },
  trainingScreens: {
    start: "Comenzar",
    continue: "Continuar",
    review: "Revisar",
    restart: "Reiniciar",
    durationInMinutes: "{number} minutos",
    percentageComplete: "{number} % completo",
    unlock:
      "Desbloquea este capítulo completando el capítulo de capacitación {number}.",
    unlockSubtitle:
      "Desbloquea más capítulos completando los capítulos de capacitación.",
    allUnlocked: "¡Has desbloqueado todos los capítulos!",
    certificate: "Certificar",
    courseComplete: "Continuar",
    endReached: "Has llegado al final",
    retainEnd:
      'Utiliza la barra superior para navegar por este capítulo, o haz clic en el botón "Atrás" para regresar a la descripción general.',
    watchListenRead: "Mira, escucha y lee más",
    trouble:
      "Parece que tienes problemas, vuelve a leer el contenido de la (las) página(s) anterior(es) e inténtalo nuevamente.",
    confirm: "Confirma tu respuesta",
    choose: "Elige una respuesta",
    skip: "Regresar >",
    viewAllTitle: "Consejo de capacitación",
    viewAll:
      "Para pasar a la página siguiente, haz clic en los íconos para ver el contenido adicional. Te hemos proporcionado vídeos, mapas y otra información útil para mejorar tu capacitación y asegurarte de que alcances el status PRO.",
    fillBlanks: "Completa el (los) espacio(s) en blanco:",
    next: "Siguiente pregunta",
    retry: "Vuelve a intentarlo",
    fastTrackText: {
      success:
        "¡Felicitaciones, has aprobado el curso Fast Track y has desbloqueado el resto de la capacitación!",
      failed:
        "Desafortunadamente no has aprobado el curso Fast Track. ¡Pero puedes retomar tu capacitación para obtener el diploma!",
    },
    fastTrack: "¡Conviértete en una Swiss Travel Superstar!",
    fastTrackExplanation:
      '¡Solo tienes que completar el cuestionario en las siguientes páginas para tener la oportunidad de ganar un FAM a Suiza!<br><br><span style="font-weight: bold">Encontrarás todas las respuestas a las preguntas de la siguiente manera:</span><br><br>1. El contenido que has aprendido en los módulos Rail Europe y Suiza<br><br>2. Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">¡Asegúrate de revisar estos recursos detalladamente antes de realizar el cuestionario! Solo las personas que hayan obtenido el mayor puntaje tendrán la oportunidad de ser invitadas al FAM.</span>',
    fastTrackButton:
      "Haz clic aquí para responder el cuestionario Swiss Superstar",
    grading: "Tu puntaje final es: {grade} %",
  },
  nav: {
    home: "Inicio",
    train: "Aprender",
    learn: "Aprender",
    retain: "Retener",
    directory: "Directorio",
    showRoom: "Exhibiciones",
    showcases: "Exhibiciones",
    offers: "Ofertas",
    promote: "Promocionar",
    sell: "Vender",
    info: "Información",
    rewards: "Premios",
    media: "Medios de comunicación",
    favorites: "Favoritos",
    contact: "Información de contacto",
    reportCard: "Ver diploma",
    accountSettings: "Ajustes de la cuenta",
    messages: "Mensajes",
    search: "Buscar",
  },
  contentHeaders: {
    specializations: "Especializaciones",
    train: "Aprender",
    retain: "Retener",
    subapps: "Módulos de los asociados de Orlando",
    maintrainings: "La fundación",
    subtrainings: "La experiencia",
  },
  pageDescriptions: {
    specializations:
      "Lleva tu estatus de Experto en Orlando al siguiente nivel completando estos capítulos para obtener insignias de especialización",
    train: "Aprende, participa y conviértete en un experto",
    showroom: "",
    retain:
      "¡Felicitaciones, has completado la capacitación! Acabas de desbloquear tu recurso de apoyo para retener tus conocimientos de experto y facilitar tus esfuerzos de ventas. Utiliza esta sección para responder de forma experta a preguntas sobre los productos o incluso realizar una presentación de ventas improvisada, en cualquier momento y lugar, y desde cualquier dispositivo.",
    promote:
      "Comparte estos elementos para despertar el interés e iniciar una conversación con (posibles) clientes.",
    sell: "Responde las preguntas y cierra la venta como un experto con recursos consolidados y apoyo comercial específico.",
    favorites: "Revisa personalmente el contenido de tu preferencia",
    search: "Revisa todo el contenido",
    subapps: "",
    maintrainings:
      "Comienza por lo básico sobre Orlando y los lugares donde se pueden alojar tus clientes.",
    subtrainings:
      "Completa estos módulos sobre todas las increíbles cosas que los clientes pueden hacer y ver en Orlando, y recibe tu certificado como experto oficial en Orlando.",
  },
  general: {
    offerBig:
      "Con tu estatus de experto vienen muchos beneficios, comenzando con ofertas exclusivas y descuentos disponibles solo para ti. Haz clic en el botón de Ofertas en la página de inicio para comenzar a cosechar las recompensas de tus esfuerzos.",
    badge: "Ver <br> insignia",
    offerMessage: "Oferta de entradas gratuitas de LEGOLAND Florida",
    unlock: "Desbloquea este elemento completando la sección Aprender.",
    next: "Siguiente",
    yes: "Sí",
    no: "No",
    previous: "Anterior",
    submit: "Enviar",
    back: "Atrás",
    close: "Cerrar",
    page: "Página",
    search: "Buscar",
    logIn: "Iniciar sesión",
    logOut: "Cerrar sesión",
    viewItem: "Ver {type}",
    imageNotFound: "No se encontró la imagen",
    noResultsFor: "No se encontraron resultados para: {{query}}",
    noFavorites: "Todavía no tienes ningún favorito.",
    noMessages: "¡Aún no has recibido ningún mensaje!",
    resultsFor: "Resultados para: {{query}}",
    showAll: "Mostrar todo",
    connectionError: "Error de conexión",
    alreadyExists: "Ya existe",
    pageNotFound: "Error 404: ¡no se encontró la página!",
    oops: "Oh oh...",
    overview: "Regresar a la descripción general",
    complete: "Continuar",
    courseComplete: "¡Capítulo completo!",
    chapterComplete: "¡Capítulo completado!",
    message: "{count} mensaje",
    messagePlural: "{count} mensajes",
    completion: "Completa la Fundación para desbloquear este objeto",
  },
  itemTypes: {
    image: "Imagen",
    brochure: "Colección",
    layout: "Diseño",
    web: "Sitio web",
    pdf: "PDF",
    carousel: "Colección",
  },
  questions: {
    dials: "Gira los diales para que coincidan con la respuesta",
    fitb: "Completa el (los) espacio(s) en blanco",
    flip: "Cambia el número para que coincida con la respuesta",
    multipleChoice: "Elige la (las) respuesta(s) correcta(s)",
    slider: "Elige la respuesta correcta usando el control deslizante",
    map: "Toca la ubicación correcta en el mapa para responder la pregunta",
    dropdown: "Elige...",
    true: "Verdadero",
    false: "Falso",
  },
  reportCard: {
    download: "Descargar",
    email: "Correo electrónico",
    print: "Imprimir",
  },
  cookies: {
    consent: "ACEPTAR",
    optout: "Darse de baja",
    settings: "Ajustes de privacidad",
    message:
      "¡No nos has comentado nada acerca de tus preferencias sobre la privacidad de datos! Está bien; sin embargo, nos gustaría ofrecerte la mejor experiencia de uso del recurso de ventas.",
    disabled: "Parece que has deshabilitado el uso de las cookies.",
    use: "{{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.",
    details: "¿Para qué se utilizan las cookies?",
    enable: "Aprende cómo habilitar tus cookies {{here}}.",
    here: "aquí",
  },
  notLoggedIn: {
    super: "No has iniciado sesión",
    title: "Necesitas iniciar sesión para ver este contenido",
    guest: "Visitante",
  },
  demo: {
    message:
      "Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.",
    consent: "¡Entendido!",
  },
  share: {
    header: "¡Comparte este recurso en tus redes sociales favoritas!",
    download: "Descargar",
  },
  sharing: {
    copyURL: "Copiar el enlace",
    copied: "Copiado",
  },
  breadCrumbs: {
    page: "Página",
  },
  onMobile: {
    header:
      "Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil",
    body: "Para descargar este programa, simplemente visita tu tienda de aplicaciones y busca {appName}, o haz clic en uno de los siguientes botones",
    benefits: {
      1: "Aprende, promociona y vende en el camino",
      2: "Capacitación multimedia en todos los dispositivos",
      3: "Certificado de finalización",
      4: "Presentaciones de ventas preparadas con anticipación",
      5: "Material promocional de gran impacto",
      6: "Directorio de productos en tiempo real",
      7: "Novedades y actualizaciones periódicas",
      header: "Esto te proporcionará:",
    },
  },
  contact: {
    vp: "Vicepresidente de Ventas de la Industria de Viajes",
    na: "Director de ventas de la industria de viajes, América del Norte",
    emea: "Director de ventas de la industria de viajes, EMEA",
    la: "Director de Ventas de la Industria de Viajes, América Latina",
  },
  directory: {
    attractions: "Atracciones",
    hotels: "Hoteles",
    dining: "Comida",
    nightlife: "La vida nocturna",
    artsculturehistory: "Arte, Cultura e Historia",
    themeparks: "Parques tematicos",
    sportsrecreationoutdoors:
      "Deportes, Recreación y Actividades al aire libre",
    otheraccommodations: "Otros alojamientos",
    shopping: "Compras",
    weddingservices: "Servicios para bodas",
    golf: "Golf",
    transportationservices: "Servicios de transporte",
    medicalservices: "Servicios médicos",
    spas: "Balnearios",
    filters: "Filtros",
    reset: "Restablecer filtros",
    view: "Ver ahora",
    amount: "Cantidad de resultados",
    retail: "Venta al por menor",
    accommodations: "Alojamientos",
    transportation: "Transporte",
    conventionservices: "Servicios de convenciones",
    visitorprofessionalservices: "Servicios profesionales y para visitantes",
    visitorandprofessionalservices: "Servicios profesionales y para visitantes",
    studentandyouthgroupfriendly: "Grupos estudiantiles y juveniles",
  },
  custom: {
    splitUsers: "Soy un...",
    brandAmbassador: "Embajador de la marca",
    travelPro: "Asesor profesional de turismo",
  },
};
